export default __webpack_public_path__ + "static/media/FSEX302.ceb8f5db.ttf";